<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-indent:0em;">Graham E Howarth is a retired primary school head teacher who lives in Bury, Lancashire.</p><br/>
<p style="text-indent:0em;">He is married to Helen and has two daughters, Sarah and Kate.</p><br/>
<p style="text-indent:0em;"><em>Alliance</em> is the first novel in his <em>Far Future</em> trilogy that moves on to <em>Containment</em> and then <em>Infinity</em>.</p><br/>
<p style="text-indent:0em;">He has also written his autobiography, <em>If Only I’d Asked</em>, plus <em>The Burrs Country Park, Bury</em>, a record in poems and pictures, including a brief history of the park. Both have been self-published for local sale<em>. A History of The Burrs, Bury</em> will also be published locally in 2022.</p><br/>
<p style="text-indent:0em;">He has been a science fiction aficionado for many years.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?61ca87e0